const definitions = {
  types: {
    FacetecDeviceSdkParams: {
      deviceKeyIdentifier: "Text",
      publicFaceMapEncryptionKey: "Text",
      productionKey: "Option<Text>",
    },
    FacetecDeviceSdkParamsV2: {
      deviceKeyIdentifier: "Text",
    },
    LivenessData: {
      faceScan: "Text",
      auditTrailImage: "Text",
      lowQualityAuditTrailImage: "Text",
    },
    UnixMilliseconds: "u64",
    BioauthStatusActive: {
      expiresAt: "UnixMilliseconds",
    },
    BioauthStatus: {
      _enum: {
        Unknown: null,
        Inactive: null,
        Active: "BioauthStatusActive",
      },
    },
    EnrollV2Result: {
      scanResultBlob: "Option<Text>",
    },
    AuthenticateV2Result: {
      authTicket: "Bytes",
      authTicketSignature: "Bytes",
      scanResultBlob: "Option<Text>",
    },
    StepV1Request: {
      requestBlob: "Text",
      context: "Option<Bytes>",
    },
    StepV1Continue: {
      context: "Bytes",
    },
    AuthenticateStepV1Done: {
      authTicket: "Bytes",
      authTicketSignature: "Bytes",
    },
    EnrollStepV1Status: {
      _enum: {
        Continue: "StepV1Continue",
        Done: "Null",
      },
    },
    AuthenticateStepV1Status: {
      _enum: {
        Continue: "StepV1Continue",
        Done: "AuthenticateStepV1Done",
      },
    },
    EnrollStepV1Request: "StepV1Request",
    EnrollStepV1Response: {
      responseBlob: "Text",
      status: "EnrollStepV1Status",
    },
    AuthenticateStepV1Request: "StepV1Request",
    AuthenticateStepV1Response: {
      responseBlob: "Text",
      status: "AuthenticateStepV1Status",
    },
  },
  rpc: {
    getFacetecDeviceSdkParams: {
      description: "Get FaceTec device sdk params",
      params: [],
      type: "FacetecDeviceSdkParams",
    },
    getFacetecDeviceSdkParamsV2: {
      description: "Get FaceTec device sdk params",
      params: [],
      type: "FacetecDeviceSdkParamsV2",
    },
    provideLivenessData: {
      description: "Provide the liveness data to the node",
      params: [{ name: "liveness_data", type: "LivenessData" }],
      type: "Null",
    },
    enroll: {
      description:
        "@deprecated — - This API method is deprecated and will be removed in an upcoming release. Use the enrollV2 method instead.",
      params: [{ name: "liveness_data", type: "LivenessData" }],
      type: "Null",
    },
    enrollV2: {
      description: "Enroll with the provided liveness data",
      params: [{ name: "liveness_data", type: "LivenessData" }],
      type: "EnrollV2Result",
    },
    authenticate: {
      description: "Authenticate with the provided liveness data",
      params: [{ name: "liveness_data", type: "LivenessData" }],
      type: "Null",
    },
    authenticateV2: {
      description: "Request auth ticket based on provided liveness data.",
      params: [{ name: "liveness_data", type: "LivenessData" }],
      type: "AuthenticateV2Result",
    },
    getFacetecSessionToken: {
      description: "Get FaceTec session token",
      params: [],
      type: "Text",
    },
    status: {
      description: "Rpc method to get bioauth status",
      params: [],
      type: "BioauthStatus<Timestamp>",
    },
    enrollStepV1: {
      description:
        "Make a step of the enroll flow with a FaceTec SDK request blob",
      params: [{ name: "request", type: "EnrollStepV1Request" }],
      type: "EnrollStepV1Response",
    },
    authenticateStepV1: {
      description:
        "Make a step of the authenticate flow with a FaceTec SDK request blob",
      params: [{ name: "request", type: "AuthenticateStepV1Request" }],
      type: "AuthenticateStepV1Response",
    },
  },
};

export default definitions;
